import { EMPTY_VALUE, FieldSchema } from "../../../Schema";
import { LinkedInstance } from "../../common/external-sources/LinkedInstances";
import { User } from "../../common/external-sources/Users";
import { Modes } from "../../common/fields/mode";
import { EntryTypes } from "../../common/fields"; 

export const inventoryNumber: FieldSchema = {
  grid: {
    displayed: true,
    order: 40,
    sortable: false,
    integerOnly: true,
  },
  name: "inventoryNumber",
  data: { maxLength: 19 },
  display: {
    displayed: true,
  },
  validation: {
    custom: {
      getter: ({ inventoryNumber }) =>
        inventoryNumber &&
        !inventoryNumber.toString().match(/^[a-zA-Z0-9]*$/) ?
          "Enter an alphanumeric value only" :
          EMPTY_VALUE,
    },
  },
  form: {
    label: "Inventory number",
    disabled: {
      getter: ({ entryType, linkedInstance, mode, currentUser }) => {
        return (
          [EntryTypes.STANDALONE_EQUIPMENT, EntryTypes.CLUSTER_SUBEQUIPMENT].includes(entryType as EntryTypes) &&
          [Modes.EDIT, Modes.BULK_EDIT].includes(mode as Modes) &&
          ["P1S Uni-Directional"].includes((linkedInstance as LinkedInstance)?.linkedInstance)
        ) && !(currentUser as User)?.isAdmin;
      },
      fields: ["entryType", "linkedInstance", "mode", "currentUser"],
    },
  },
};

export default (): FieldSchema => inventoryNumber;
